import {useTranslation} from 'react-i18next'
import DatePickerV2 from '../../../../components/DatePickerV2/DatePickerV2'
import * as TableUI from '../../../../components/Table/Table'
import {TextInputV2} from '../../../../components/TextInputV2'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {filterSelector, setFilterSalesOffices} from '../../../../redux/slices/filterSlices'
import './RowFilter.scss'

export const RowFilter = () => {
  const {t} = useTranslation()
  const {filterSalesOffices: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterSalesOffices({...filter, ...value}))
  }

  return (
    <TableUI.TRowFilter>
      <td>
        <div>&nbsp;</div>
      </td>
      <td>
        <TextInputV2
          placeholder={t('Sales Office Code')}
          value={filter?.sales_office ?? ''}
          onChange={({target}) => handleFilterChange({sales_office: target.value})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('order-tanggal-dari')}
          isSelectsRange={false}
          startDate={filter?.from_date ?? ''}
          onChange={({startDate}) => handleFilterChange({from_date: startDate})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('order-tanggal-berakhir')}
          isSelectsRange={false}
          startDate={filter?.to_date ?? ''}
          onChange={({startDate}) => handleFilterChange({to_date: startDate})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Controlling Area')}
          value={filter?.controlling_area ?? ''}
          onChange={({target}) => handleFilterChange({controlling_area: target.value})}
        />
      </td>
    </TableUI.TRowFilter>
  )
}
